// Original project sketches, not screenshots or proprietary system diagrams.
export function ProjectArt({ type }) {
  if (type === 'consolidation') {
    return (
      <div className="project-art art-consolidation" aria-hidden="true">
        <div className="art-caption"><span>STICKLEY</span><span>THE CONSOLIDATION</span></div>
        <div className="site-sketch sketch-brand"><span className="sketch-window">○ ○ ○</span><strong>Brand site</strong><span>Brand content & collections</span><i /><i /></div>
        <div className="site-sketch sketch-retail"><span className="sketch-window">○ ○ ○</span><strong>Retail site</strong><span>Products & shopping</span><div className="sketch-grid"><i /><i /><i /></div></div>
        <svg className="sketch-arrow" viewBox="0 0 190 80" fill="none"><path d="M12 6c-20 75 92 70 160 31m-25-4 27 3-10 24" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round" /></svg>
        <span className="sketch-result">One Shopify storefront.</span>
        <span className="illustration-label">PROJECT SKETCH / NOT A SCREENSHOT</span>
      </div>
    );
  }
  return (
    <div className="project-art art-collectors" aria-hidden="true">
      <div className="art-caption"><span>STICKLEY</span><span>THE COLLECTOR’S SHOP</span></div>
      <div className="collectors-art">
        <p>Objects &<br /><em>collectibles.</em></p>
        <div className="object object-vase" />
        <div className="object object-frame"><svg viewBox="0 0 60 80" fill="none"><path d="M14 66c47 0 33-63 13-52S9 38 31 41s18 23-6 19" stroke="currentColor" strokeWidth="2" strokeLinecap="round" /></svg></div>
        <div className="object object-orb" />
        <div className="object-shelf" />
      </div>
      <span className="illustration-label">COLLECTION ILLUSTRATION</span>
    </div>
  );
}
